/**
Copyright [2022] [https://www.merac.com
 */
export const ThemeModeEnum = {
	LIGHT: 'light',
	DARK: 'dark',
	REAL_DARK: 'realDark'
}
